function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,47.058824%,62.745098%)",
      fillOpacity: 1
    },
    d: "M 19.109375 4.460938 C 18.300781 4.460938 17.644531 5.113281 17.644531 5.925781 C 17.644531 6.734375 18.300781 7.390625 19.109375 7.390625 C 19.917969 7.390625 20.574219 6.734375 20.574219 5.925781 C 20.574219 5.113281 19.917969 4.460938 19.109375 4.460938 Z M 19.109375 4.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,47.058824%,62.745098%)",
      fillOpacity: 1
    },
    d: "M 12.589844 6.34375 C 9.1875 6.34375 6.429688 9.101562 6.429688 12.503906 C 6.429688 15.90625 9.1875 18.667969 12.589844 18.667969 C 15.996094 18.667969 18.753906 15.90625 18.753906 12.503906 C 18.753906 10.871094 18.105469 9.300781 16.953125 8.144531 C 15.796875 6.988281 14.226562 6.339844 12.589844 6.34375 Z M 12.589844 16.449219 C 10.992188 16.453125 9.546875 15.492188 8.929688 14.011719 C 8.316406 12.535156 8.652344 10.832031 9.785156 9.699219 C 10.917969 8.566406 12.621094 8.230469 14.097656 8.84375 C 15.578125 9.460938 16.539062 10.90625 16.535156 12.503906 C 16.535156 14.683594 14.769531 16.449219 12.589844 16.449219 Z M 12.589844 16.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,47.058824%,62.745098%)",
      fillOpacity: 1
    },
    d: "M 17.480469 24.988281 L 7.484375 24.988281 C 3.320312 24.988281 -0.0546875 21.613281 -0.0546875 17.449219 L -0.0546875 7.476562 C -0.0546875 3.3125 3.320312 -0.0664062 7.484375 -0.0664062 L 17.460938 -0.0664062 C 21.625 -0.0664062 25 3.3125 25 7.476562 L 25 17.460938 C 24.992188 21.613281 21.632812 24.976562 17.480469 24.988281 Z M 7.507812 2.371094 C 6.136719 2.367188 4.824219 2.910156 3.855469 3.878906 C 2.886719 4.847656 2.34375 6.160156 2.347656 7.527344 L 2.347656 17.515625 C 2.359375 20.34375 4.65625 22.636719 7.484375 22.640625 L 17.460938 22.640625 C 20.304688 22.640625 22.613281 20.335938 22.621094 17.492188 L 22.621094 7.507812 C 22.613281 4.660156 20.308594 2.355469 17.460938 2.347656 Z M 7.507812 2.371094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b6fb606620c50389efb504dc517cb42f.svg";
export { ForwardRef as ReactComponent };